import { render, staticRenderFns } from "./ResourcesIdParent.vue?vue&type=template&id=603826be&scoped=true"
import script from "./ResourcesIdParent.vue?vue&type=script&lang=js"
export * from "./ResourcesIdParent.vue?vue&type=script&lang=js"
import style0 from "./ResourcesIdParent.vue?vue&type=style&index=0&id=603826be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603826be",
  null
  
)

export default component.exports